import { RefObject, useEffect, useRef } from 'react';

export const useOutsideClick = <TRef extends HTMLElement>(ref: RefObject<TRef>, handler: (event: Event) => void) => {
  const handlerRef = useRef(handler);
  // eslint-disable-next-line react-hooks/refs -- we explicitly don't want to execute the useEffect hook every time the handler function changes; assigning to the ref here prevents re-registering of the document events
  handlerRef.current = handler;

  useEffect(() => {
    const listener = (event: MouseEvent | TouchEvent) => {
      // Do nothing if clicking ref's element or descendent elements
      if (!ref.current || ref.current.contains(event.target as Node)) {
        return;
      }
      handlerRef.current(event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref]);
};
